
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M174.06,299.13a44.8,44.8,0,0,1,44.52-44.86H576.79a44.68,44.68,0,0,1,44.52,44.86V522.49a44.92,44.92,0,0,1-44.76,44.86H218.82a44.79,44.79,0,0,1-44.76-44.86ZM341,209.55H452.55A17.48,17.48,0,0,1,468.09,219l18.12,35.24H307.31L325.44,219A17.47,17.47,0,0,1,341,209.55Z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"234.4","cy":"312.63","r":"22.36"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M396.76,299A111.81,111.81,0,1,0,508.58,410.81,111.89,111.89,0,0,0,396.76,299Zm0,190a78.18,78.18,0,1,1,78.18-78.18A78.23,78.23,0,0,1,396.76,489Z"}})])])
          )
        }
      }
    